'use client';

import { c as _c } from "react/compiler-runtime";
import { TextPassage } from '@petsmart-ui/sparky';
import { useWatch } from 'react-hook-form';
import { useCurbsideQuery } from '@libs/common-next';
import type { Product, TailoredApiData } from '@libs/common-types';
import { CurbsideInfoDetail } from '../CurbsideInfoDetail';
import { getShippingRestrictionText } from '../product-details';
import { useMiniPdpDrawer } from './model/use-mini-pdp-drawer';
type MiniPdpDisclaimersProps = Readonly<{
  product: Product;
  tailored: TailoredApiData | null;
}>;
export function MiniPdpDisclaimers(t0) {
  const $ = _c(14);
  const {
    product,
    tailored
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      name: "fulfilmentMethod"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const selectedMethod = useWatch(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      name: "selectedSku"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const selectedSku = useWatch(t2);
  const isOpen = useMiniPdpDrawer(_temp);
  const close = useMiniPdpDrawer(_temp2);
  const {
    curbsideData
  } = useCurbsideQuery();
  let t3;
  if ($[2] !== product || $[3] !== selectedMethod) {
    t3 = selectedMethod === "sth" ? getShippingRestrictionText(product.deliveryMethods.STH.poBoxRestricted) : null;
    $[2] = product;
    $[3] = selectedMethod;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const shippingRestriction = t3;
  const storeId = selectedSku ? tailored?.variants[selectedSku]?.BOPIS?.storeId : undefined;
  const storeOffersCurbside = Boolean(storeId && tailored?.bopisStoreData?.[storeId]?.offersCurbsidePickup);
  const showCurbside = selectedMethod === "bopis" && storeOffersCurbside && Boolean(curbsideData);
  if (!shippingRestriction && !showCurbside) {
    return null;
  }
  let t4;
  if ($[5] !== shippingRestriction) {
    t4 = shippingRestriction && <TextPassage data-testid="po-box">{shippingRestriction}</TextPassage>;
    $[5] = shippingRestriction;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== close || $[8] !== isOpen || $[9] !== showCurbside) {
    t5 = showCurbside && <CurbsideInfoDetail showBackButton={true} forceClosed={!isOpen} onCloseAll={close} />;
    $[7] = close;
    $[8] = isOpen;
    $[9] = showCurbside;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div className="mini-pdp-drawer__disclaimers" data-testid="mini-pdp-disclaimers">{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}
function _temp2(state_0) {
  return state_0.close;
}
function _temp(state) {
  return state.isOpen;
}